/**
 * useCreateSurcharge Hook
 *
 * Mutation hook for creating a surcharge. On success, optimistically prepends
 * the new surcharge onto every cached list query so consumers (e.g. price-modifier
 * dropdowns) see it immediately, then invalidates the lists for a background
 * refetch from the server.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createSurcharge,
  surchargesQueryKeys,
  type SurchargesListResponse,
} from '../api/surcharges';

export function useCreateSurcharge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSurcharge,
    onSuccess: ({ surcharge }) => {
      queryClient.setQueriesData<SurchargesListResponse>(
        { queryKey: surchargesQueryKeys.lists() },
        (prev) =>
          prev
            ? { ...prev, surcharges: [surcharge, ...prev.surcharges] }
            : prev,
      );
      queryClient.invalidateQueries({ queryKey: surchargesQueryKeys.lists() });
    },
  });
}
